import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig, Text} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'

export const PDPBannerPromo = ({label, bodycopy}) => {
    const styles = useStyleConfig('PDPBannerPromo')

    return (
        <Flex {...styles.container} data-testid="pdp-banner-promo-container">
            {label && (
                <Flex {...styles.label} data-testid="pdp-banner-promo-label">
                    <Text>{label}</Text>
                </Flex>
            )}
            {bodycopy && (
                <Text>
                    <SanitizedHtml
                        {...styles.bodycopy}
                        html={bodycopy}
                        data-testid="pdp-banner-promo-bodycopy"
                    />
                </Text>
            )}
        </Flex>
    )
}

PDPBannerPromo.propTypes = {
    label: PropTypes.string,
    bodycopy: PropTypes.string,
}
